import React from "react"
import styled from "styled-components"

import { BodyCopy, StandardContainer, SectionWrapper } from "../../common"

const StyledTextContent = styled(StandardContainer)`
  img {
    width: 100%;
    height: auto;
    margin: 0.5em 0;
  }
`

const TextWrapper = styled.div`
  width: 100%;
  text-align: ${(props) => (props.isBlog ? "left" : "center")};
  @media ${(props) => props.theme.breakpoints.ns} {
    text-align: left;

    p,
    a,
    li {
      font-size: ${(props) => props.isBlog && "14px"};
    }
  }
  @media ${(props) => props.theme.breakpoints.large} {
    text-align: left;
  }
`
export const TextContent = ({
  text_content,
  anchor_id,
  block_background,
  isBlog,
}) => {
  return (
    <SectionWrapper $bgColor={block_background}>
      <StyledTextContent id={anchor_id} $wrappedStandard>
        <TextWrapper isBlog={isBlog}>
          <BodyCopy dangerouslySetInnerHTML={{ __html: text_content?.html }} />
        </TextWrapper>
      </StyledTextContent>
    </SectionWrapper>
  )
}
